import Box from '@material-ui/core/Box'
import DNAImage from 'assets/images/DNA_min.webp'
import FileUploader from 'components/fileUploader/FileUploader'
import StaticPageWrapper from 'components/staticPage/StaticPageWrapper'
import { useDataContext } from 'context/DataContext'
import { useNavigate } from 'react-router'
import { Tumor, ReportViewerData } from 'reportViewer'
import { useStaticStyles } from 'styles/shared.styles'

const possibleFileExtensions = ['json']

const NotFound = () => {
    const {
        wrapper,
        imageWrapper,
        descriptionWrapper,
        fileUpload,
        imageStyle
    } = useStaticStyles()

    const { setCompounds, setTargets, setDrivers, setTumor, setFileName } = useDataContext()
    const navigate = useNavigate()

    const handleFileChange = (
        _file: File[] | null,
        data: ReportViewerData | null
    ) => {
        if (_file?.[0]) {
            setFileName(_file[0].name)
        }
        const molecularProfileAnalysis = data?.molecularProfileAnalysis

        const compounds = data?.compounds || []
        const targets = molecularProfileAnalysis?.targets || []
        const drivers = molecularProfileAnalysis?.molecularBiomarkers || []
        const tumor = data?.tumor || ({} as Tumor)

        setCompounds(compounds)
        setTargets(targets)
        setDrivers(drivers)
        setTumor(tumor)

        navigate('/compounds')
    }

    return (
        <StaticPageWrapper title="Upload JSON" withContact={true}>
            <Box className={wrapper}>
                <Box>
                    <Box className={imageWrapper}>
                        <img alt="dna" src={DNAImage} className={imageStyle} />
                    </Box>
                    <Box className={descriptionWrapper}>
                        <FileUploader
                            label={'Drop files or click to browse'}
                            name="molecularProfileFiles"
                            types={possibleFileExtensions}
                            classes={fileUpload}
                            onChange={handleFileChange}
                        />
                    </Box>
                </Box>
            </Box>
        </StaticPageWrapper>
    )
}

export default NotFound
